import { datadogRum } from '@datadog/browser-rum';
import type { ModalProps } from '@usealloy/component-library';
import {
  Box,
  Modal,
  Text,
} from '@usealloy/component-library';
import React, { useEffect } from 'react';
import type { Document } from '~/entities/types';

import { refreshEntityDocuments } from '~/application-review/redux/thunks';
import { useAppDispatch } from '~/store/reduxHooks';
import { DocumentReviewer } from './DocumentReviewer';

// ============================================================
//     TYPES
// ============================================================
interface Props {
  documents: Document[];
  onClose: ModalProps['onClose'];
}

// ============================================================
//     COMPONENT
// ============================================================
export const DocumentReviewModalV2: React.FC<Props> = ({
  documents,
  onClose,
}) => {
  const appDispatch = useAppDispatch();

  useEffect(() => {
    datadogRum.addAction('DocReviewV2Modal', { action: 'OPEN_MODAL' });
    return () => {
      datadogRum.addAction('DocReviewV2Modal', { action: 'CLOSE_MODAL' });
    };
  }, []);

  return (
    <Modal
      isOpen
      onClose={onClose}
      size="xl"
      header={(
        <Box justifyContent="flex-start" gap={4}>
          <Text size={4} weight={500}>
            Entity Documents
          </Text>
        </Box>
      )}
      contentStyle={{
        maxHeight: 'calc(100vh - 200px)',
        borderBottom: 'none',
        borderTop: 'none',
        paddingTop: 0,
      }}
    >
      <Box direction="column" alignItems="flex-start" justifyContent="flex-start" gap={2} style={{ flexGrow: 1 }}>
        <DocumentReviewer
          documents={documents}
          onRenameSuccess={({ entity_token }) => {
            appDispatch(refreshEntityDocuments({ entityToken: entity_token }));
          }}
          onReviewSuccess={({ entity_token }) => {
            appDispatch(refreshEntityDocuments({ entityToken: entity_token }));
          }}
          shouldPinReviewActions
        />
      </Box>
    </Modal>
  );
};
